import {
  useSelector,
} from 'react-redux';
import { useNavigate } from 'react-router';

import {
  WorkoutEvent,
} from '@gymcloud/core';

import {
  getUiState,
} from 'web-selectors';
import {
  Icon,
  Button,
  Tooltip,
} from 'web-components';
import {
  Flex,
  Text,
  SVG,
} from 'web-styled';
import * as S from './styled';

const mapState = (state) => ({
  openedTooltips: getUiState('openedTooltips')(state),
});

interface Props {
  event: WorkoutEvent,
  onFinished: { (): void },
}

export default ({
  event,
  onFinished,
}: Props) => {
  const navigate = useNavigate();
  const { openedTooltips } = useSelector(mapState);
  return (
    <S.Navigation>
      <Flex align="center" spacing={10}>
        <S.A
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate(-1);
          }}
        >
          <SVG.ChevronLeft size={14} />
        </S.A>
        <Text
          color="#9ea0a1"
          size="16px"
        >
          {event.workout_name}
        </Text>
      </Flex>
      <Flex align="center" spacing={10}>
        <S.Date>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={14}
            height={14}
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M8 2v4" />
            <path d="M16 2v4" />
            <rect width="18" height="18" x="3" y="4" rx="2" />
            <path d="M3 10h18" />
          </svg>
          <span>
            {event.start}
          </span>
        </S.Date>
        <Flex align="center">
          <S.NavPrev
            to={`/events/${event.prev_id}/results`}
            style={{ cursor: event.prev_id ? 'pointer' : 'not-allowed' }}
            onClick={(e) => {
              if (!event.prev_id) {
                e.preventDefault();
              }
            }}
          >
            <SVG.ChevronLeft size={14} />
          </S.NavPrev>
          <S.NavNext
            to={`/events/${event.next_id}/results`}
            style={{ cursor: event.next_id ? 'pointer' : 'not-allowed' }}
            onClick={(e) => {
              if (!event.next_id) {
                e.preventDefault();
              }
            }}
          >
            <SVG.ChevronRight size={14} strokeWidth={3} />
          </S.NavNext>
        </Flex>
        <Tooltip
          body="Click Finished when you are done."
          isOpen={openedTooltips.some(el => el.key === 'finish_workout')}
        >
          <Button
            ghost
            appearance="primary"
            onClick={onFinished}
          >
            Finished
          </Button>
        </Tooltip>
      </Flex>
    </S.Navigation>
  );
};
